import Joi from 'joi';
// import { YEARS } from '../LegalParameters/Constants';

export default Joi.object({
	income: Joi.number()
		.min(0)
		.error(() => ({
			message: 'Vyměřovací základ musí být celé kladné číslo.',
		})),
	children: Joi.number()
		.integer()
		.min(1)
		.max(2),
	length: Joi.number()
		.min(1)
		.max(43)
		.positive()
		.error(() => ({
			message: 'Počet měsíců musí být celé kladné číslo od 1 do 43.',
		})),
	subsidy: Joi.number()
		.min(1)
		.positive()
		.error(() => ({
			message: 'Výše RP musí být celé kladné číslo.',
		})),
	// year: Joi.valid(YEARS),
	year: Joi.number()
		.min(2018)
		.max(2020),
});
